import { render, staticRenderFns } from "./BindingMobile.vue?vue&type=template&id=1d04dd0b&scoped=true"
import script from "./BindingMobile.vue?vue&type=script&lang=js"
export * from "./BindingMobile.vue?vue&type=script&lang=js"
import style0 from "./BindingMobile.vue?vue&type=style&index=0&id=1d04dd0b&prod&scoped=true&lang=css"
import style1 from "./BindingMobile.vue?vue&type=style&index=1&id=1d04dd0b&prod&lang=less&scoped=true"
import style2 from "./BindingMobile.vue?vue&type=style&index=2&id=1d04dd0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04dd0b",
  null
  
)

export default component.exports